const config = {};
for (const configElement of document.getElementsByClassName('js-configurations')) {
  try {
    Object.assign(config, JSON.parse(configElement.text));
  } catch (error) {
    reportError(error);
  }
}

export const {
  isMobile,
  cartDeleteURL,
  searchAutoCompleteURL,
  comparePreviewURL,
  compareItemLimit,
  cartAddURL,
  language,
  market
} = config;

// is primary pointer having limited accuracy, or the primary input mechanism can hover
export const isTouch = matchMedia('(pointer: coarse), (hover: none)').matches;

export const autocompleteHistoryLSKey = 'search-historic';

export const compareItemsLSKey = 'compareItems';
